var angular = require('angular');
var _module = require('./index');


_module
    .directive('fillHeight', [
        '$timeout',

        function($timeout) {
            return {
                restrict: 'A',
                link: function($scope, elem, attrs) {
                    function setHeight() {
                        var windowHeight = $(window).height() + $scope.$eval(attrs.fillHeight);
                        var childrenHeight = 0;

                        elem.children().each(function() {
                            childrenHeight += $(this).outerHeight();
                        });

                        // console.log('WH', windowHeight);
                        // console.log('CH', childrenHeight);
                        // console.log($scope.$eval(attrs.fillHeight));

                        if($(window).width() < 600) {
                            elem.height(null);
                        } else {
                            elem.height(windowHeight > childrenHeight? windowHeight : childrenHeight);
                        }
                    }

                    $(window).on('resize', setHeight);

                    $timeout(function() {
                        $(window).resize();
                    });
                }
            };
        }
    ])
;